import React from 'react';
import lessonExplorerUrl from './urls';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';
import getResourceId from '../../helpers/getResourceId';
import RoleErrorComponent from '../../components/Error/RoleErrorComponent';

const LessonExplorer = React.lazy(() => import(/* webpackChunkName: "LessonExplorer" */ '.'));
const allowedRoles = ['TEACHER', 'SCHOOL_ADMIN', 'DISTRICT_OWNER'];

const routes = [
    <AuthenticatedLayoutRoute
        key="lesson-explorer"
        path={`${lessonExplorerUrl}/:gradeid?/:moduleid?`}
        RoleErrorComponent={RoleErrorComponent}
        roles={allowedRoles}
    >
        <LessonExplorer />
    </AuthenticatedLayoutRoute>,
];

export const generateLessonExplorerUrl = (gradeId, moduleId) => {
    if (gradeId && moduleId) {
        const resourceId = getResourceId(moduleId);
        return `${lessonExplorerUrl}/${gradeId}/${btoa(resourceId)}`;
    }
    if (gradeId) {
        return `${lessonExplorerUrl}/${gradeId}`;
    }
    return lessonExplorerUrl;
};

export default routes;
